<template>
  <vue-page-transition name="fade-in-down">
    <v-content class="bg-content">
      <div class="about">
        <v-container grid-list-xl style="padding: 10px; top:20px">
          <v-card dark class="theme-bg-card-2 card-animate-2">
            <v-app-bar
              color="rgba(12, 22, 27, 0.9)"
              max-height="75"
              height="75"
              elevation="3"
              dense
              dark
            >
          <v-toolbar-title>
            <v-avatar size="40">
              <img src="@/assets/AccountIconv3.png" />
            </v-avatar>
            Accounts
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              dense
              outlined
              class="mr-1"
              v-on:change="searchAccount"
            ></v-text-field>
          </div>

          <v-btn
            class="ma-2"
            outlined
            color="white"
            value="Go Back From Whence You Came!"
            onclick="history.back(-1)"
            >Previous Page</v-btn
          >

          <v-btn
            elevation="2"
            outlined
            dark
            depressed
            color="white"
            @click="openForm"
            >Create</v-btn
          >
        </v-app-bar>

        <v-data-table
          class="theme-bg-card-2"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :headers="headers"
          :items="accountsList"
          :search="search"
          max-width="750"
          id="virtual-scroll-table"
          v-scroll:#virtual-scroll-table-5="onScroll"
        >
          <template v-slot:item.controls="props">
            <i
              class="fa fa-trash thrash"
              @click="deleteConfirmation(props.item)"
            ></i>
            <i
              class="fa fa-pencil thrash"
              @click="editAccount(props.item)"
              style="margin-left: 20px"
            ></i>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="showConfirmation" max-width="390">
        <v-card class="theme-bg-card-4">
          <v-card-title class="text-h5">
            Are you sure you want to delete this account?
          </v-card-title>

          <v-card-text :v-if="itemToBeDeleted._id">
            Account Name: {{ itemToBeDeleted.accountName }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="showConfirmation = false"
            >
              Disagree
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              :loading="loading3"
              :disabled="loading3"
              @click="deleteAccount()"
            >
              Agree
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="overlay" opacity="0.98" z-index="9">
        <v-card
          v-scroll.self="onScroll"
          style="background-color: rgba(48, 64, 87, 0.8)"
          class="overflow-y-auto popup-container theme-bg-card-3"
        >
          <v-layout row wrap fluid>
            <v-flex xs12 sm12 md12>
              <v-list-item class="mb-margin">
                <v-list-item-content>
                  <v-form
                    ref="accountform"
                    lazy-validation
                    aria-autocomplete="off"
                  >
                    <v-banner
                      class="justify-center text-h5 font-weight-light"
                      sticky
                    >
                      <v-avatar size="70">
                        <img src="@/assets/AccountIconv3.png" />
                      </v-avatar>
                      Accounts
                    </v-banner>

                    <h6 class="display-6 font-weight-thin">
                      General Information
                    </h6>

                    <v-row>
                      <v-text-field
                        v-model="formFields.accountName"
                        class="mg-lr14"
                        label="Account Name"
                        hint="Unicorn Enterprises"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="formFields.firstName"
                        class="mg-lr14"
                        label="First Name"
                        hint="Tom"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="formFields.lastName"
                        class="mg-lr14"
                        label="Last Name"
                        hint="Smith"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        class="mg-lr14"
                        v-model="formFields.phone"
                        label="Phone Number"
                        hint="8185551234"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        class="mg-lr14"
                        v-model="formFields.email"
                        label="Email"
                        hint="tom@unicorn.com"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-select
                        class="mg-lr14"
                        v-model="formFields.accountSource"
                        :items="accountSource"
                        label="Account Source"
                        hint="Online, eBay, Facebook, Google, Craigslist, OfferUp"
                        outlined
                      ></v-select>
                      <v-select
                        class="mg-lr14"
                        v-model="formFields.accountStatus"
                        :items="accountStatus"
                        label="Account Status"
                        hint="Created, Pending, Canceled, Approved"
                        outlined
                      ></v-select>
                      <v-select
                        class="mg-lr14"
                        v-model="formFields.accountType"
                        :items="accountType"
                        label="Account Type"
                        hint="Retail, Wholesale, Online"
                        outlined
                      ></v-select>
                    </v-row>

                    <v-row>
                      <v-text-field
                        class="mg-lr14"
                        v-model="formFields.street"
                        label="Street"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <v-text-field
                        class="mg-lr14"
                        v-model="formFields.state"
                        label="State"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="formFields.city"
                        class="mg-lr14"
                        label="City"
                        outlined
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="formFields.zipcode"
                        class="mg-lr14"
                        label="Zip Code"
                        outlined
                        required
                      ></v-text-field>
                    </v-row>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mx-2"
                        color="red"
                        outlined
                        @click="resetForm()"
                        >Cancel</v-btn
                      >
                      <v-btn
                        class="mx-2"
                        color="green"
                        v-if="!editForm"
                        :loading="loading3"
                        :disabled="loading3"
                        outlined
                        @click="submitForm"
                        >Save</v-btn
                      >
                      <v-btn
                        class="mx-2"
                        color="green"
                        v-if="editForm"
                        :loading="loading3"
                        :disabled="loading3"
                        outlined
                        @click="updateAccount"
                        >Update</v-btn
                      >
                    </v-card-actions>
                    <v-flex class="space2" />
                  </v-form>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
        </v-card>
      </v-overlay>
     </v-container>
      </div>
    </v-content>
  </vue-page-transition>
</template>

<script>
export default {
  name: 'Accounts',
  components: {},
  data() {
    return {
      ownerOptions: [
        'John Salinas',
        'Danny Barlavi',
        'David Barlavi',
        'Amelia Lang',
        'Chris Mags',
        'Christina Vega',
      ],
      accountSource: [
        'Online',
        'eBay',
        'Facebook',
        'Google',
        'OfferUp',
        'Craiglist',
        'AAFLC',
        'StockTech',
      ],
      accountType: [
        'Retail',
        'Wholesale',
        'Online',
      ],
      accountStatus: [
        'Created', 
        'Pending', 
        'Canceled', 
        'Approved'
      ],
      scrollInvoked: 0,
      items: [],
      accountsList: [],
      searchKey: '',
      search: '',
      optionIndex: 0,
      itemToBeDeleted: '',
      loading3: false,
      isLoading: false,
      productLoader: false,
      editForm: false,
      showConfirmation: false,
      overlay: false,
      rows: 100,
      itemsPerPage: 10,
      currentField: 0,
      tableLoader: false,
      date: new Date(),
      formFields: {
        accountName: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        accountSource: '',
        accountStatus: '',
        accountType: '',
        street: '',
        state: '',
        city: '',
        zipcode: '',
      },
      modal_date_picker: false,
      form_valid: true,
      headers: [
        {
          text: 'Account',
          value: 'accountName',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Phone',
          value: 'phone',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Email',
          value: 'email',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Account Source',
          value: 'accountSource',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Account Status',
          value: 'accountStatus',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Account Type',
          value: 'accountType',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: '',
          value: 'controls',
          align: 'center',
          sortable: false,
          divider: true,
        },
      ],
    };
  },

  mounted() {
    this.getAccountsList();
    Event.$on('openForm', () => {
      // Event.$off();
      console.log('Starting form in ' + this.$route.path);
      if (this.$route.path !== '/accounts') {
        return;
      }
      this.readOutLoud('Please fill the following details');
      setTimeout(() => {
        this.readOutLoud('Account Name');
        this.startListining();
      }, 3500);
      this.overlay = true;
    });

    Event.$on('editFromRecord', (data) => {
      if (this.$route.path !== '/accounts') {
        return;
      }
      console.log(data.msg);
      this.editAccount(this.accountsList[0]);
    });

    Event.$on('searchFromRecord', (data) => {
      if (this.$route.path !== '/accounts') {
        return;
      }
      this.search = data.msg;
      this.searchAccount(data.msg);
    });

    Event.$on('formDetails', (data) => {
      console.log(data);

      switch (data.msg) {
        case 'next':
          this.currentField++;
          this.navigateField();

          break;
        case 'previous':
          this.currentField--;
          this.navigateField();

          break;
        case 'submit':
          this.readOutLoud('Please verify your account details');
          break;
        case 'verified':
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },
  printLead: function() {
    window.print();
  },

  methods: {
    initialize() {
      this.accountsList = [];
    },

    onScroll() {
      this.scrollInvoked++;
    },

    searchAccount: async function() {
      console.log(this.search);
      if (!this.search) this.getAccountsList();

      this.isLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}account-form/search`,
        {
          method: 'POST',
          body: JSON.stringify({ searchText: this.search }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      this.isLoading = false;

      console.log(json);
      this.accountsList = json.result;
    },

    getAccountsList: async function() {
      this.tableLoader = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}account-form/all`
      );
      const json = await response.json();
      console.log(json);
      this.accountsList = json.result;
      this.tableLoader = false;
    },

    submitForm: async function() {
      console.log(this.formFields);
      // console.log(this.inputs[0])

      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}account-form/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('Account Created');
        this.getAccountsList();
        this.resetForm();
      }, 800);
    },

    deleteConfirmation: function(item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },

    deleteAccount: async function() {
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}account-form/delete`,
        {
          method: 'POST',
          body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;

      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getAccountsList();
      }, 800);
    },

    editAccount: function(data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
    },

    updateAccount: async function() {
      this.loading3 = true;

      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}account-form/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.formFields), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getAccountsList();
        this.resetForm();
      }, 800);
    },

    resetForm: function() {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.formFields = {
        accountName: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        accountSource: '',
        accountStatus: '',
        accountType: '',
        street: '',
        state: '',
        city: '',
        zipcode: '',
      };
    },

    openForm: function() {
      this.overlay = true;
      this.items = [];
    },

    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1000);
    },

    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },

    readOutLoud: function(msg) {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.lang = 'en-GB';
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      this.speak = msg;
    },

    fillForm: function(msg) {
      switch (this.currentField) {
        case 0:
          this.formFields.accountName = msg;
          break;
        case 1:
          this.formFields.firstName = msg;
          break;
        case 2:
          this.formFields.lastName = msg;
          break;
        case 3:
          this.formFields.phone = msg;
          break;
        case 4:
          this.formFields.email = msg;
          break;
        case 5:
          var accountSource = this.accountSource.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (accountSource) {
            this.formFields.accountSource = accountSource;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 6:
          this.formFields.accountStatus = msg;
          break;
        case 7:
          this.formFields.accountType = msg;
          break;
        case 8:
          this.formFields.street = msg;
          break;
        case 9:
          this.formFields.state = msg;
          break;
        case 10:
          this.formFields.city = msg;
          break;
        case 11:
          this.formFields.zipcode = msg;
          break;
      }

      this.currentField++;
      this.navigateField();
    },

    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('Account Name?');
          break;
        case 1:
          this.readOutLoud('First name?');
          break;
        case 2:
          this.readOutLoud('Last name?');
          break;
        case 3:
          this.readOutLoud('Phone Number?');
          break;
        case 4:
          this.readOutLoud('Email address?');
          break;
        case 5:
          this.readOutLoud('Account source?');
          break;
        case 6:
          this.readOutLoud('Account status?');
          break;
        case 7:
          this.readOutLoud('Account type?');
          break;
        case 8:
          this.readOutLoud('Street?');
          break;
        case 9:
          this.readOutLoud('State?');
          break;
        case 10:
          this.readOutLoud('City?');
          break;
        case 11:
          this.readOutLoud('Zip code?');
          break;
      }

      this.startListining();
    },
  },
};
</script>

<style scoped src="../components/css/Style.css">
@import '../components/css/Style.css';
</style>